import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
} from "react-admin";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'


const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />

  </Filter>
);

const ContentReviewLabelList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Labels"

      filters={<ListFilter />}

    >
      <Datagrid rowClick={"show"}>
        <TextField source="id" />
        <TextField source="label1" label="Label1" />
        <TextField source="label2" label="Label2" />
        <TextField source="option2a" label="Option 1" />
        <TextField source="option2b" label="Option 2" />
        <TextField source="label3" label="Label3" />
        <TextField source="option3a" label="Option 1" />
        <TextField source="option3b" label="Option 2" />
        <TextField source="label4" label="Label4" />
        <TextField source="option4a" label="Option 1" />
        <TextField source="option4b" label="Option 2" />
        <TextField source="label5" label="Label 5" />
        <TextField source="option5a" label="Option 1" />
        <TextField source="option5b" label="Option 2" />
        <TextField source="option5c" label="Option 3" />

        <TextField source="label6" label="Label 6" />
        <TextField source="option6a" label="Option 1" />
        <TextField source="option6b" label="Option 2" />
        <TextField source="option6c" label="Option 3" />

        <TextField source="label7" label="Label 7" />
        <TextField source="option7a" label="Option 1" />
        <TextField source="option7b" label="Option 2" />
        <TextField source="option7c" label="Option 3" />
        <TextField source="post_id" label="Current Post Id" />

        {useCheckPermissions('AddonandVideoTaskLabels_Edit') ? <EditButton /> : null}
      </Datagrid>
    </List>
  );
};

export default ContentReviewLabelList;
